export default "__VITE_ASSET__Dt5Sma26__"